// extracted by mini-css-extract-plugin
export default {"divider":"register_divider__-zfHG","label-color":"register_label-color__1HV01","bgImg":"register_bgImg__RZkEU"};